module.exports = __webpack_public_path__ + "static/conspiracy-theories-in-american-history-38c8d587433510669c94c94dc401500d.jpg";